import { Skeleton } from '@nextui-org/react'
import React from 'react'

function PageContentLoader() {
  return (
    <div className="mx-auto max-w-screen-lg space-y-3">
      <Skeleton className="w-3/5">
        <div className="h-3 w-3/5 bg-default-200"></div>
      </Skeleton>
      <Skeleton className="w-3/5">
        <div className="h-3 w-3/5 bg-default-200"></div>
      </Skeleton>
      <Skeleton className="w-4/5">
        <div className="h-3 w-4/5 bg-default-200"></div>
      </Skeleton>
      <Skeleton className="w-4/5">
        <div className="h-3 w-4/5 bg-default-200"></div>
      </Skeleton>
      <Skeleton className="w-2/5">
        <div className="h-3 w-2/5 bg-default-300"></div>
      </Skeleton>
      <Skeleton className="w-2/5">
        <div className="h-3 w-2/5 bg-default-300"></div>
      </Skeleton>
    </div>
  )
}

export default PageContentLoader
